import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AmplifyHttpClient } from '../../auth/http.amplify-httpclient';
import { loaderTypes } from '@app/shared/component/loader/loader';

@Injectable({
  providedIn: 'root',
})
export class InboxSettingsService {
  constructor(private readonly _httpService: AmplifyHttpClient, private _httpClient: HttpClient) {}

  // method to get block email list
  getBlockEmailList(wid) {
    const url = wid ? `api/user/inbox-block-list/${wid}` : `api/user/inbox-block-list`;
    return this._httpService.get(url).pipe(
      map((responce) => {
        return responce;
      })
    );
  }
  multiAttachment(fileId) {
    const url = `api/data-extraction/inbox-multi-attachment/${fileId}`;
    return this._httpService.get(url).pipe(
      map((responce) => {
        return responce;
      })
    );
  }
  deleteInboxSubItem(attachmentIds: number[]) {
    const url = `api/data-extraction/vault-user-inbox-subitem-mark-as-linked`;
    return this._httpService.patch(url, {
      vault_user_inbox_subitem_ids: attachmentIds,
    });
  }
  getAutomationEmailList(wid) {
    const url = wid ? `api/user/inbox-automation/${wid}` : `api/user/inbox-automation/`;
    return this._httpService.get(url).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  updateAutomationEmail(data) {
    const url = `api/user/inbox-automation`;
    return this._httpService.patch(url, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  deleteAutomationEmail(id) {
    const url = `api/user/inbox-automation/${id}`;
    return this._httpService.delete(url).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getInboxAttachmentSubItem(id) {
    const url = `api/data-extraction/inbox-sub-items-suggestion/${id}`;
    return this._httpService.get(url).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  updateInboxAttachmentIsLinkedComplete(data) {
    const url = `api/vault/inbox-attatch-is-linked`;
    return this._httpService.patch(url, data).pipe(
      map((response) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  // method to add email to block email list
  addEmailToBloackList(email: string, wid?: string) {
    const url = `api/user/inbox-block-list`;
    const payload: any = { email: email };
    if (wid) {
      payload.workspace_id = wid;
    }
    return this._httpService.post(url, payload).pipe(map((response) => response));
  }
  // add Email for automation

  addEmailToAutomation(data) {
    const url = `api/user/inbox-automation`;
    return this._httpService.post(url, data).pipe(
      map((responce) => {
        return responce;
      })
    );
  }
  // method to delete email from block email list
  deleteEmailFromBlockList(id: number) {
    const url = `api/user/inbox-block-list/${id}`;
    return this._httpService.delete(url).pipe(
      map((responce) => {
        return responce;
      })
    );
  }

  // method to get inbox data
  getInboxData(userId: number | string, w_id = null, isArchive = null, isTrash = null) {
    let url = `api/vault/inbox/${userId}`;
    const queryParams = [];
    if (w_id != null) {
      queryParams.push(`w_id=${w_id}`);
    }
    if (isArchive) {
      queryParams.push(`is_archive=true`);
    }
    if (isTrash) {
      queryParams.push(`is_trash=true`);
    }
    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }
    return this._httpService.get(url, null, loaderTypes.mainAnimation).pipe(
      map((responce) => {
        return responce;
      })
    );
  }

  // method to get attachment url
  getAttachmentUrl(userId: number | string, fileId: number) {
    const url: string = `api/vault/inbox-file-download-url/${userId}/${fileId}`;
    return this._httpService.get(url).pipe(
      map((responce) => {
        return responce;
      })
    );
  }
  createDuplicateInboxAttachment(data) {
    const url: string = `api/vault/inbox-duplicate`;
    return this._httpService.post(url, data).pipe(
      map((responce) => {
        return responce;
      })
    );
  }

  // method to get dowload blob file
  downloadBlob(url: string): Observable<Blob> {
    return this._httpClient.get(url, {
      responseType: 'blob',
    });
  }

  // method to delete inbox attachments
  updateInboxAttachmentFileName(data) {
    const url = `api/vault/inbox-attachment-file-name`;
    return this._httpService.patch(url, data).pipe(
      map((responce) => {
        return responce;
      })
    );
  }

  // method to delete inbox attachments
  deleteInboxAttachments(attachmentIds: number[], userId: number | string) {
    const url = `api/vault/inbox-delete`;
    return this._httpService
      .post(url, {
        inbox_id: attachmentIds,
        user_id: userId,
      })
      .pipe(
        map((responce) => {
          return responce;
        })
      );
  }

  /**
   * method to get categories
   * @param vaultUserId
   * @param vaultId
   * */
  getCategoryFolders(vaultUserId: number | string, vaultId: number) {
    const url: string = `api/vault/categories-list/${vaultUserId}/${vaultId}`;
    return this._httpService.get(url).pipe(
      map((responce) => {
        return responce;
      })
    );
  }

  /**
   * method to get sub categories
   * @param vaultUserId
   * @param vaultId
   * */
  getSubCategoryFolders(vaultUserId: number | string, vaultId: number) {
    const url: string = `api/vault/subfolders-list/${vaultUserId}/${vaultId}`;
    return this._httpService.get(url).pipe(
      map((responce) => {
        return responce;
      })
    );
  }

  /**
   * method to get parent level folders
   * @param vaultUserId
   * @param vaultId
   * */
  getParentLevelFolders(vaultUserId: number | string, vaultId: number) {
    const url: string = `api/vault/parentfolders-list/${vaultUserId}/${vaultId}`;
    return this._httpService.get(url).pipe(
      map((responce) => {
        return responce;
      })
    );
  }

  /**
   * Method to move inbox
   * @param attachmentIds
   * @param vaultUserId
   * @param vaultId
   */
  moveToInbox(attachmentIds: number[], vaultUserId: number | string, vaultId: number) {
    const url: string = `api/vault/inbox-move`;
    return this._httpService
      .post(
        url,
        {
          inbox_id: attachmentIds,
          user_id: vaultUserId,
          vault_user_group_id: vaultId,
        },
        loaderTypes.mainAnimation
      )
      .pipe(
        map((responce) => {
          return responce;
        })
      );
  }

  /**
   * Method to get all forms for user
   * @param userId : vault user id
   */
  getAllForms(userId: number | string, w_id = null) {
    let url: string = `api/vault/forms-user/${userId}`;
    if (w_id != null) {
      url = url + `?w_id=${w_id}`;
    }
    return this._httpService.get(url, null, loaderTypes.mainAnimation).pipe(
      map((responce) => {
        return responce;
      })
    );
  }

  /**
   * Method to attach inbox
   * @param attachmentIds
   * @param vaultUserId
   * @param formId
   */
  attachFileToReminder(reminder_id) {
    const url: string = `api/vault/attached-file-with-reminder/${reminder_id}`;
    return this._httpService.get(url).pipe(
      map((responce) => {
        if (responce.status == 200) {
          return responce.data;
        } else {
          return responce;
        }
      })
    );
  }
  /**
   * Method to attach inbox
   * @param attachmentIds
   * @param vaultUserId
   * @param formId
   */
  attachToInbox(attachmentIds: number[], vaultUserId: number | string, formId: number, vault_user_form_reminder_id: number = null, is_linked = true) {
    const url: string = `api/vault/inbox-attatch`;
    return this._httpService
      .post(
        url,
        {
          inbox_id: attachmentIds,
          user_id: vaultUserId,
          is_linked: is_linked,
          vault_user_form_id: formId,
          vault_user_form_reminder_id: vault_user_form_reminder_id,
        },
        loaderTypes.mainAnimation
      )
      .pipe(
        map((responce) => {
          return responce;
        })
      );
  }

  markLinkedInboxItems(data) {
    const url: string = `api/vault/inbox-attatch-mark-multiple`;
    return this._httpService.patch(url, data).pipe(
      map((responce) => {
        return responce;
      })
    );
  }

  attachToInboxSubItem(attachmentIds: number[], vaultUserId: number | string, formId: number, vault_user_form_reminder_id: number = null) {
    const url: string = `api/vault/vault-user-inbox-subitem-attach-form`;
    return this._httpService
      .post(
        url,
        {
          vault_user_inbox_subitem_id: attachmentIds,
          user_id: vaultUserId,
          vault_user_form_id: formId,
          vault_user_form_reminder_id: vault_user_form_reminder_id,
        },
        loaderTypes.mainAnimation
      )
      .pipe(
        map((responce) => {
          return responce;
        })
      );
  }
  /**
   * Method to attach inbox
   * @param attachmentIds
   * @param formId
   */
  attachToInboxTask(attachmentIds: number[], vaultUserId: number | string, task_id: number = null) {
    const url: string = `api/vault/inbox-attatch-task`;
    return this._httpService
      .post(url, {
        inbox_id: attachmentIds,
        user_id: vaultUserId,
        task_id: task_id,
      })
      .pipe(
        map((responce) => {
          return responce;
        })
      );
  }
}
